import React, { useState } from "react";
import {
  Box,
  TextField,
  Button,
  Typography,
  Checkbox,
  FormControlLabel,
  CircularProgress,
} from "@mui/material";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import logo from "../assets/images/landing.png";
import { useNavigate } from "react-router-dom";
import "../css/Login.css"; // Import the CSS file
import { useDispatch, useSelector } from "react-redux";
import { loginUser } from "../redux/slices/LoginSlice"; // Adjust the path to match your file structure

const LoginPage = () => {
  const validationSchema = Yup.object({
    userName: Yup.string().required("User Name is required"),
    password: Yup.string().required("Password is required"),
  });
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loadingLogin, error } = useSelector((state) => state.LoginSlice);

  const handleLogin = async (values) => {
    const { userName, password } = values;

    const result = await dispatch(
      loginUser({ username: userName, password })
    ).unwrap();
    if (result) {
      const { access_token, refresh_token } = result?.data;
 
      // Save tokens to localStorage
      localStorage.setItem("access_token", access_token);
      localStorage.setItem("refresh_token", refresh_token);
      navigate("/agentSelection"); // Navigate on successful login
    }
  };

  return (
    <Box className="login-page-container">
      <div className="login-grid-container">
        {/* Left Side */}
        <Box className="login-left-side">
          <Box className="left-section-content">
            <Typography className="left-section-title">
              Optimize Your Team with
            </Typography>
            <h2 className="left-section-subtitle">
              Our Super Intelligent AI <br />
              Digital Agents
            </h2>
            <Typography className="left-section-description">
              Our advanced AI digital coworkers have precision design and
              adaptive learning capabilities to revolutionize workflows and
              bring efficiency and innovation to the process.
            </Typography>
            <Box className="left-section-logo">
              <img src={logo} alt="Docketry Logo" />
            </Box>
          </Box>
        </Box>

        {/* Right Side */}
        <Box className="login-right-side">
          <Box className="form-container">
            <h2 className="form-title">Login</h2>

            <Formik
              initialValues={{
                userName: "",
                password: "",
                showPassword: false,
              }}
              validationSchema={validationSchema}
              onSubmit={handleLogin}
            >
              {({ values, handleChange, handleBlur, errors, touched }) => (
                <Form>
                  <Typography
                    sx={{
                      marginTop: "10px",
                      fontWeight: "550",
                      color: "#4F4F4F",
                    }}
                  >
                    User Name
                  </Typography>
                  <TextField
                    className="text-field"
                    label="User Name"
                    name="userName"
                    value={values.userName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.userName && Boolean(errors.userName)}
                    helperText={touched.userName && errors.userName}
                    margin="dense"
                  />
                  <Typography
                    sx={{
                      marginTop: "10px",
                      fontWeight: "550",
                      color: "#4F4F4F",
                    }}
                  >
                    Password
                  </Typography>
                  <TextField
                    className="text-field"
                    placeholder="xxxxxxxxxx"
                    name="password"
                    type={!values.showPassword?"password":'text'}
                    value={values.password}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.password && Boolean(errors.password)}
                    helperText={touched.password && errors.password}
                    margin="dense"
                  />

                  <Box className="show-password-section">
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="showPassword"
                          checked={values.showPassword}
                          onChange={handleChange}
                        />
                      }
                      label="Show Password"
                      sx={{
                        fontSize: "0.3rem",
                      }}
                    />
                    <label className="forgot-password-link">
                      Forgot Password?
                    </label>
                  </Box>
                  <Button
                    type="submit"
                    sx={{
                      width: "30%",
                      height: "40px",
                      marginTop: "10px",
                      borderRadius: "8px",
                      backgroundColor: "#1E3899",
                    }}
                    variant="contained"
                    disabled={loadingLogin}
                  >
                    {loadingLogin ? (
                      <CircularProgress size={24} sx={{ color: "#fff" }} />
                    ) : (
                      <Typography className="submit-button-text">
                        Login
                      </Typography>
                    )}
                  </Button>
                  {/* {error && (
                    <Typography
                      sx={{
                        color: "red",
                        marginTop: "10px",
                        textAlign: "center",
                      }}
                    >
                      {error}
                    </Typography>
                  )} */}
                </Form>
              )}
            </Formik>

            <label variant="body2" target="_blank" className="footer-link">
              www.docketry.ai
            </label>
          </Box>
        </Box>
      </div>
    </Box>
  );
};

export default LoginPage;
